module.exports = __webpack_public_path__ + "media/images/talent/feature-01-21d446419ea59218f9b632acf4f7c9fb.png";